function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.243 50l4.467 4.17L55.6 50l-3.89-4.169zM0 8.339L42.775 54.17l8.935-8.339L8.935 0zm42.775 37.492L0 91.661 8.935 100 51.71 54.17z"
});

var SvgChevronRight = function SvgChevronRight(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 55.601 100"
  }, props), _ref);
};

export default SvgChevronRight;